import React, { useState } from "react"
import { useStaticQuery, graphql, Link } from "gatsby"

const Search = ({ forwardedRef }) => {
  const { allStrapiArticle } = useStaticQuery(graphql`
    {
      allStrapiArticle {
        edges {
          node {
            slug
            title
            subtitle
            description
          }
        }
      }
    }
  `)
  const [searchText, setSearchText] = useState("")
  const [searchResults, setSearchResults] = useState([])

  const handleCHange = e => {
    let searchValue = e.target.value
    let suggestion = []
    if (searchValue.length > 0) {
      suggestion = allStrapiArticle.edges.sort().filter(article => {
        return (
          article.node.title
            .toLowerCase()
            .includes(searchValue.toLowerCase()) ||
          article.node.subtitle
            .toLowerCase()
            .includes(searchValue.toLowerCase()) ||
          article.node.description
            .toLowerCase()
            .includes(searchValue.toLowerCase())
        )
      })
    }
    setSearchResults(suggestion)
    setSearchText(searchValue)
  }

  const getSuggestions = () => {
    if (searchResults.length === 0 && searchText !== "") {
      return <p>Sin coincidencias...</p>
    }
    return (
      <ul className="search-list">
        {searchResults.map((article, index) => {
          return (
            <div key={index} className="search">
              <Link to={`/blog/${article.node.slug}`}>
                <li>{article.node.title}</li>
              </Link>
            </div>
          )
        })}
      </ul>
    )
  }

  return (
    <div className="search-box">
      <input
        ref={forwardedRef}
        type="text"
        placeholder="Search..."
        onChange={handleCHange}
      />
      {getSuggestions()}
    </div>
  )
}

export default Search
